import { render } from "./HeroSlider.vue?vue&type=template&id=a153c67c"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__